export enum OfferedEmployeeStatus {
	PROFILE_SHORTLIST = "PROFILE_SHORTLIST",
	PROFILE_ACCEPTED_BY_CUSTOMER = "PROFILE_ACCEPTED_BY_CUSTOMER",
	PROFILE_IDEA = "PROFILE_IDEA",
	PROFILE_NOT_OFFERED = "PROFILE_NOT_OFFERED",
	PROFILE_DECLINED = "PROFILE_DECLINED",
}
